import React, { Suspense, lazy } from "react";
import { Routes, Route } from "react-router-dom";
import Loader from "@components/common/Loader";
import "@assets/css/custom.css";
import { I18nextProvider } from 'react-i18next';
import i18n from './i18n';

const Main = lazy(() => import("./pages/Main"));

const App = () => {
    return (
        <I18nextProvider i18n={i18n}>
        <Suspense fallback={<Loader />}>
            <Routes>
                <Route path="/" element={<Main />} />
                <Route path="/:category/:couponCode" element={<Main />} />
                <Route path="*" element={<div className="not-found-page">404 Not Found!</div>} />
            </Routes>
        </Suspense>
        </I18nextProvider>

    );
};

export default App;
